import React from "react"
import { string, node, bool, func } from "prop-types"
import { Link as RouterLink } from "react-router-dom"
import Typograph from "components/Typograph"

const TypographLink = ({
  id,
  children,
  to,
  onClick,
  isExternal,
  target,
  preset = "link",
  size,
  weight,
  isActive,
  classNames
}) => {
  const commonsProps = {
    preset,
    size,
    weight,
    classNames
  }

  return isExternal ? (
    <a
      id={id}
      href={to}
      target={target}
      onClick={onClick}
      rel="noopener noreferrer"
    >
      <Typograph isActive={isActive} htmlTag="span" {...commonsProps}>
        {children}
      </Typograph>
    </a>
  ) : (
    <RouterLink id={id} to={to} onClick={onClick}>
      <Typograph isActive={isActive} htmlTag="span" {...commonsProps}>
        {children}
      </Typograph>
    </RouterLink>
  )
}

TypographLink.propTypes = {
  id: string,
  children: node,
  to: string.isRequired,
  isExternal: bool,
  target: string,
  toLinkBtn: bool,
  onClick: func,
  preset: string,
  size: string,
  weight: string,
  isActive: bool,
  classNames: string
}

TypographLink.defaultProps = {
  children: null,
  target: "",
  isExternal: false,
  onClick: null
}

export default TypographLink



// WEBPACK FOOTER //
// ./src/shared/components/TypographLink/index.js